import { ProductDataError } from '@/lib/api/product-data-client'

/**
 * The toast description for a checkout the API Worker would not open.
 *
 * A refusal (a 4xx from `/api/customer/payments/*`) carries a message written for the customer that
 * says why and what to do next, such as "Your company has not been formed yet. Restart your formation
 * from the dashboard...", so it is shown as it is. Anything else (no connection, a 5xx, an expired
 * session) gets the caller's own retry copy, and so does a 4xx with no JSON envelope (an edge page),
 * whose only message is the client's own `HTTP <status>` placeholder.
 */
const NO_ENVELOPE_MESSAGE = /^HTTP \d{3}$/

export function checkoutErrorDescription(error: unknown, fallback: string): string {
  if (!(error instanceof ProductDataError)) return fallback
  if (error.status < 400 || error.status >= 500 || error.status === 401 || !error.message) return fallback
  if (NO_ENVELOPE_MESSAGE.test(error.message)) return fallback
  // The one refusal whose message is not written for the customer.
  if (error.code === 'ALREADY_PAID') return 'You already have this plan. Manage it from Billing.'
  return error.message
}
